import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const register = async (userData) => {
  const response = await axios.post(`${API_URL}/auth/register`, userData);
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

const login = async (userData) => {
  const response = await axios.post(`${API_URL}/auth/login`, userData);
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

const logout = () => {
  localStorage.removeItem('user');
};

const loadUser = async () => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.token) {
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };
    try {
      const response = await axios.get(`${API_URL}/auth/profile`, config);
      const userData = { ...response.data, token: user.token };
      localStorage.setItem('user', JSON.stringify(userData));
      return userData;
    } catch (error) {
      // If profile fetch fails, return cached user data
      return { ...user };
    }
  }
  throw new Error('No token found');
};

const authService = {
  register,
  login,
  logout,
  loadUser,
};

export default authService;